import * as _28 from "./cosmos";
export const cosmos_proto = {
  ..._28
};